import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseApi } from '../../../dtos/ResponseApi';
import { RacaResponse } from '../../../dtos/core/raca/RacaResponse';

@Injectable({
  providedIn: 'root'
})
export class RacaService {
  private baseUrl = `${environment.apiUrl}/core/raca`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ResponseApi<RacaResponse[]>> {
    return this.http.get<ResponseApi<RacaResponse[]>>(this.baseUrl);
  }
}
